/** Stable identity for a FAQ (the API gives no id): its normalised question.
 *  Also what the package page de-duplicates on. */
export const faqKey = (question: string): string =>
  question.trim().toLowerCase();

/** Answers rendered into the page HTML; the rest load when opened. */
export const FAQ_INLINE_ANSWERS = 10;
